import { mat4 } from 'gl-matrix';
import { RenderObject } from '../RenderObject';

export interface AttachmentHolder {
  setAttachment(attachPoint: string, obj: RenderObject): Attachment;

  getAttachment(attachPoint: string): Attachment;

  getAttachments(attachPoint: string): Attachment[];

  clearAttachment(attachPoint: string): Attachment[];

  clearSingleAttachment(attachPoint: string, obj: RenderObject): Attachment | undefined;

  preRenderAttachments(modelMatrix: mat4): void;
}

export class Attachment {
  modelMatrix: mat4;
  offsetMatrix: mat4;
  boneMatrix: mat4;

  constructor(
    public attachPoint: string,
    public object: RenderObject,
    public parent: RenderObject,
  ) {
    this.modelMatrix = mat4.create();
    this.offsetMatrix = mat4.create();
    this.boneMatrix = mat4.create();
  }
}
